<script lang="ts">
  import { navigating } from "$app/state";

  // Top loading bar for client-side navigations. Only shows when a navigation
  // takes longer than SHOW_DELAY, so prefetched pages switch without a flash.
  const SHOW_DELAY = 150;

  let progress = $state(0);
  let visible = $state(false);

  $effect(() => {
    if (!navigating.to) return;

    let trickle: ReturnType<typeof setInterval> | undefined;
    const show = setTimeout(() => {
      progress = 0.1;
      visible = true;
      // Ease towards 90% — the remaining part is filled once the page is ready.
      trickle = setInterval(() => {
        progress += (0.9 - progress) * 0.1;
      }, 200);
    }, SHOW_DELAY);

    // Runs when navigation finishes (navigating.to becomes null) or a new one starts.
    return () => {
      clearTimeout(show);
      clearInterval(trickle);
      if (visible) {
        progress = 1;
        setTimeout(() => {
          visible = false;
          progress = 0;
        }, 300);
      }
    };
  });
</script>

<div class="nav-progress" class:visible role="progressbar" aria-hidden={!visible} aria-label="Seite wird geladen / Loading page" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(progress * 100)}>
  <div class="nav-progress-bar" style="transform:scaleX({progress})"></div>
</div>

<style>
  .nav-progress {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    z-index: 300;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  .nav-progress.visible {
    opacity: 1;
  }
  .nav-progress-bar {
    height: 100%;
    background: var(--accent);
    box-shadow: 0 0 8px var(--accent);
    transform-origin: left;
    transition: transform 0.2s ease-out;
  }

  @media (prefers-reduced-motion: reduce) {
    .nav-progress-bar {
      transition: none;
    }
  }
</style>
